import React from 'react';
import Dropdown from "../../Dropdown";

import { Bomb, Bug, ChevronDown, Folder, Ghost } from "../../../icons";
import Button from "../../Button";
import { HeaderLinksRoutes } from "../index";
import { createStyles } from "./styles";
import ToolsDropdownOption from "../ToolsDropdownOption";





var DevToolsDropdown = function DevToolsDropdown(_ref) {var customMainColor = _ref.customMainColor;
  var classes = createStyles({ customMainColor: customMainColor });

  var imCelticsOptions = [
  {
    value: HeaderLinksRoutes.OUTPUT_ISSUE_TRACKER,
    renderFunc: function renderFunc(key) {return /*#__PURE__*/(
        React.createElement(ToolsDropdownOption, {
          key: key,
          href: HeaderLinksRoutes.OUTPUT_ISSUE_TRACKER,
          icon: /*#__PURE__*/React.createElement(Bug, { className: classes.bugIcon }),
          linkText: "Output Issue Tracker",
          customMainColor: customMainColor }));}


  },
  {
    value: HeaderLinksRoutes.BE_ERROR_TRACKER,
    renderFunc: function renderFunc(key) {return /*#__PURE__*/(
        React.createElement(ToolsDropdownOption, {
          key: key,
          href: HeaderLinksRoutes.BE_ERROR_TRACKER,
          icon: /*#__PURE__*/React.createElement(Bomb, { className: classes.bugIcon }),
          linkText: "BE Error Tracker",
          customMainColor: customMainColor }));}


  },
  {
    value: HeaderLinksRoutes.FILE_EXCHANGE,
    renderFunc: function renderFunc(key) {return /*#__PURE__*/(
        React.createElement(ToolsDropdownOption, {
          key: key,
          href: HeaderLinksRoutes.FILE_EXCHANGE,
          icon: /*#__PURE__*/React.createElement(Folder, null),
          linkText: "File Exchange Dashboard",
          customMainColor: customMainColor }));}


  }];


  var ToolsButton = /*#__PURE__*/
  React.createElement(Button, {
    type: "text",
    leftIconProp: /*#__PURE__*/React.createElement(Ghost, null),
    rightIconProp: /*#__PURE__*/React.createElement(ChevronDown, null),
    size: "small",
    className: classes.dropdownButton }, "Dev Tools");





  return /*#__PURE__*/(
    React.createElement(Dropdown, {
      name: "dev-tools",
      className: classes.toolDropdown,
      options: imCelticsOptions,
      openedElement: ToolsButton,
      closedElement: ToolsButton }));


};

export default DevToolsDropdown;
//# sourceMappingURL=index.js.map